
import { Component, Prop, Vue } from 'vue-property-decorator';
import StandardModal from '@/components/shared/suites/StandardModal.vue';

interface ImageItem {
	url: string;
	alt?: string;
}

@Component<ImageDisplayModal>({
	components: {
		StandardModal
	}
})
export default class ImageDisplayModal extends Vue {
	@Prop({ type: Boolean, default: false }) show!: boolean;
	@Prop({ type: Array, required: true }) images!: ImageItem[];
	@Prop({ type: String, required: true }) title!: string;
	@Prop({ type: String, default: '' }) errorMessage!: string;

	private imageErrors: boolean[] = [];
	private imageLoading: boolean[] = [];

	private created(): void {
		this.imageErrors = new Array(this.images.length).fill(false);
		this.imageLoading = new Array(this.images.length).fill(true);
	}

	private closeModal(): void {
		this.$emit('close');
	}

	private onImageLoad(index: number): void {
		this.$set(this.imageLoading, index, false);
	}

	private onImageError(index: number): void {
		this.$set(this.imageErrors, index, true);
		this.$set(this.imageLoading, index, false);
	}
}
